import { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { useCartStore } from '@/stores/cartStore';
import { useReviewsSummary } from './shared';

export const MobileHomeBar = () => {
  const summary = useReviewsSummary();
  const isCartOpen = useCartStore((state) => state.isCartOpen);
  const [topVisible, setTopVisible] = useState(true);
  const [selectorVisible, setSelectorVisible] = useState(false);
  const visible = !topVisible && !selectorVisible && !isCartOpen;

  useEffect(() => {
    const top = document.getElementById('home-top');
    const selector = document.getElementById('escolha');
    if (!top || !selector) return;

    const topObserver = new IntersectionObserver(([entry]) => setTopVisible(entry.isIntersecting), { threshold: 0.01 });
    const selectorObserver = new IntersectionObserver(([entry]) => setSelectorVisible(entry.isIntersecting), { threshold: 0.08 });
    topObserver.observe(top);
    selectorObserver.observe(selector);
    return () => {
      topObserver.disconnect();
      selectorObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    document.body.classList.toggle('home-mobile-bar-visible', visible);
    return () => document.body.classList.remove('home-mobile-bar-visible');
  }, [visible]);

  if (!summary?.totalReviews) return null;

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-v2-ink/10 bg-background/95 px-4 pt-2 shadow-lg backdrop-blur transition-transform duration-300 md:hidden ${visible ? 'translate-y-0' : 'translate-y-full pointer-events-none'}`}
      style={{ paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))' }}
      aria-hidden={!visible}
    >
      <div className="mx-auto flex min-h-12 max-w-md items-center justify-between gap-3">
        <div className="min-w-0 text-sm text-v2-ink" aria-label={`${summary.averageRating.toFixed(1)} de 5 estrelas em ${summary.totalReviews} avaliações`}>
          <span className="flex" aria-hidden>
            {[1, 2, 3, 4, 5].map((value) => <Star key={value} className="h-3.5 w-3.5 fill-brand-amber text-brand-amber" />)}
          </span>
          <span className="font-semibold">{summary.averageRating.toFixed(1).replace('.', ',')}</span>
          <span className="text-v2-muted"> · {summary.totalReviews} avaliações</span>
        </div>
        <a href="#escolha" className="inline-flex min-h-12 shrink-0 items-center justify-center rounded-full bg-v2-ink px-5 text-sm font-semibold text-v2-bg">
          Escolher o meu
        </a>
      </div>
    </div>
  );
};